const state = () => ({
  isValid: false,
  zipCode: ''
});

const getters = {
  isValid(state) {
    return state.isValid;
  },
  zipCode(state) {
    return state.zipCode;
  }
};

const mutations = {
  setIsValid(state, payload) {
    state.isValid = payload;
  },
  updateZipCode(state, payload) {
    state.zipCode = payload;
  },
  resetStore(storeState) {
    Object.assign(storeState, state());
  }
};

const actions = {
  updateZipCode({ commit }, payload) {
    commit('updateZipCode', payload);
  }
};

export const zipCode = {
  state,
  getters,
  mutations,
  actions,
  namespaced: true
};
